import { Component } from '@angular/core';

@Component({
  selector: 'app-mfe-layout',
  template: `
    <div class="mfe-layout">
      <router-outlet></router-outlet>
    </div>
  `,
  styleUrls: ['./mfe-layout.component.scss']
})
export class MfeLayoutComponent {
  constructor() { }
}
